import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class Progressbar extends DesigntimeComponent {
    static staticName = "Progressbar";
    static staticId = "progressbar";

    constructor(identifyer) {
        super(identifyer, 1);
    }

    getRuntimeView() {
        let $progressbar = $("#progressbar-container");
        let $clone = $progressbar.clone(true);
        $progressbar.hide();
        $clone.show();
        return $clone;
    }
}

export { Progressbar }
